import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaClipboardList, FaFileAlt, FaHistory, FaCog, FaBars, FaTimes } from "react-icons/fa";
import "./Sidebar.css"; 
import "../Button/Button";
import "../Worksheet/Worksheet";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
    <div className="hamburger" onClick={toggleSidebar}>
    {isOpen ? <FaTimes /> : <FaBars />}
    </div>
     
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>

      <div className="sidebar-brand">Hazop </div>
      <ul className="sidebar-menu">
        <li className="sidebar-item">
        <Link to="/worksheet" className="sidebar-link">
          <FaClipboardList className="icon" /> Hazop Worksheets
          </Link>
        </li>
        <li className="sidebar-item">
          <FaFileAlt className="icon" /> Reports
        </li>
        <li className="sidebar-item">
          <FaHistory className="icon" /> Audit Logs
        </li>
        <li className="sidebar-item">
          <FaCog className="icon" /> Settings
        </li>
      </ul>
    </div>
    </>
  );
};

export default Sidebar;
